import { motion } from "framer-motion";
import { Ship, TrendingDown, PackageCheck, CheckCircle2 } from "lucide-react";
import { IMG, IMPORTER_BENEFITS } from "@/config";
import { SectionHeading } from "@/components/Section";
import { Reveal, stagger, fadeUp } from "@/components/Reveal";

const ICONS = [TrendingDown, PackageCheck, CheckCircle2];

export default function Importer() {
  return (
    <section data-testid="direct-importer" className="py-24 md:py-32 bg-cream">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        {/* Left content */}
        <div>
          <SectionHeading
            chapter="03 / Direct Import Network"
            overline="Direct Importers"
            title={<>Direct importers. Better prices. Reliable supply.</>}
            lead="We directly source and import selected foodservice products and restaurant supplies from trusted manufacturers in India and China. By reducing unnecessary middlemen, we offer better pricing, dependable availability and wholesale quantities suited for commercial kitchens."
          />
          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }} className="mt-9 space-y-4">
            {IMPORTER_BENEFITS.map((b, i) => {
              const Icon = ICONS[i];
              return (
                <motion.div key={b.title} variants={fadeUp} className="flex gap-4 rounded-2xl border border-forest/15 bg-white p-5">
                  <span className="shrink-0 grid place-items-center h-11 w-11 rounded-xl bg-sage text-forest">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div>
                    <h4 className="font-display text-lg text-forest">{b.title}</h4>
                    <p className="text-sm text-forest/70 mt-1 leading-relaxed">{b.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </motion.div>
        </div>

        {/* Right visual */}
        <Reveal delay={0.1}>
          <div className="relative">
            <div className="absolute -inset-3 rounded-[2.2rem] bg-butter rotate-2" />
            <div className="relative rounded-[2rem] overflow-hidden border border-forest/15">
              <img src={IMG.spiceMarket} alt="Imported spices and ingredients quality checked at the warehouse" className="w-full h-[560px] object-cover" />
              <div className="absolute top-5 left-5 inline-flex items-center gap-2 rounded-full bg-forest/90 backdrop-blur text-cream px-4 py-2">
                <Ship className="h-4 w-4 text-butter-deep" />
                <span className="overline text-butter">Imports · India &amp; China</span>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
